import React, { FunctionComponent } from 'react';
import { SbBlokData, storyblokEditable } from '@storyblok/react';

import { ContactBar, Footer as FooterComponent } from '@savebetter/components';

import { LinkProps } from './Link';
import { MediaProps } from './Media';
import { RichText, RichTextProps } from './RichText';
import { Section } from './Section';

interface Column {
  heading: string;
  links: LinkProps[];
}

interface ContactBar extends SbBlokData {
  email: string;
  phoneNumber: string;
  workingHours: string;
}

interface Blok extends SbBlokData {
  title: string;
  contactBar: ContactBar[];
  socialBox?: SbBlokData;
  columns: Column[];
  topLogo: MediaProps[];
  bottomLogo?: MediaProps[];
  text: RichTextProps;
}

interface FooterProps {
  blok: Blok;
}

export const Footer: FunctionComponent<React.PropsWithChildren<FooterProps>> = ({ blok }) => {
  const {
    topLogo = [{ img: '', alt: '' }],
    bottomLogo = [{ img: '', alt: '' }],
    contactBar = [],
    columns = [],
    text
  } = blok;
  if (typeof window !== 'undefined' && localStorage.getItem('mobileApp') === 'true') {
    return null;
  }
  const footerColumns = columns.map(({ heading, links }) => ({
    header: heading,
    links: links.map(({ url: href, text, target }) => {
      const link = href.includes('blob.core') ? `https://assets-us.raisin.com/en-us/${href.split('/')[4]}` : href;
      return {
        href: link,
        text,
        target
      };
    })
  }));

  return (
    <div {...storyblokEditable(blok)}>
      {contactBar.length > 0 && (
        <div className="bg-black-10">
          <Section className="py-0" width="md" blok={contactBar[0]} hasPaddingBottom={false} hasPaddingTop={false}>
            <ContactBar
              email={contactBar[0].email}
              phoneNumber={contactBar[0].phoneNumber}
              workingHours={contactBar[0].workingHours}
            />
          </Section>
        </div>
      )}
      <div className="bg-black">
        <Section className="py-0" width="md" hasPaddingBottom={false} hasPaddingTop={false}>
          <FooterComponent
            columns={footerColumns}
            footerParagraphs={<RichText className="text-xs" content={text} />}
            headerLogo={{ src: topLogo[0].img, alt: topLogo[0].alt, size: 'xs' }}
            footerLogo={
              bottomLogo.length > 0 ? { src: bottomLogo[0].img, alt: bottomLogo[0].alt, size: 'md' } : undefined
            }
          />
        </Section>
      </div>
    </div>
  );
};
